const FULL_PACK_IDS: string[] = ['3'];

const isFullPack = (id: string, isPack: boolean): boolean =>
  isPack && FULL_PACK_IDS.includes(id);

export default isFullPack;
